import React, { useState, useEffect, useRef, useCallback } from "react";
import cn from "classnames";

import styles from "./SwappingStation.module.scss";
import EnergyComponentChartSwap from "./EnergyComponentChartSwap";
import EnergyComponentsLine from "./EnergyComponentsLineSwapStation";
import EnergyComponentChartSessionTime from "./EnergyComponentChartSessionTime";
import Master from "screen/Master";
import TableAndSearch from "components/common/TableAndSearch";
import { Link, useHistory } from "react-router-dom";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import { getRequest, postRequest } from "../../services/axiosBaseClient";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import LocalStorageService from "services/tokenlocalstorage.service";
import NewTableAndSearchMasterFilter from "components/common/NewTableAndSearchMasterFilter";
const Styles = styled.div`
  table {
    th,
    td {
      white-space: wrap;
    }
  }
  .double-screen-pagination {
    margin-top: 40px !important;
    height: 50px;
    padding: 0;
    right: 18px !important;
  }
`;

let multiselectArray = [];
var offset = 0;
var pageLimit = 10;

function SwappingStation(props) {
  const filterInitialValue = {
    siteId: "",
    swapStationId: "",
    state: "",
    stateId: "",
    city: "",
    cityId: "",
    zoneId: "",
    startDate: parseInt(Date.now() / 1000) - 86400,
    endDate: parseInt(Date.now() / 1000),
    time: "HOUR_24",
  };

  const [filterData, setChargerMultiSelecct] = useState(multiselectArray);
  const [filter, setFilter] = useState(filterInitialValue);
  const [swapStationFault, setSwapSationFault] = useState([]);
  const [swapStationsData, setSwapStationsData] = useState([]);
  const [swapData, setSwapData] = useState([]);
  const [selectTime, setSelectTime] = useState("HOUR_24");
  const [sitesList, setSitesList] = useState([]);
  const [chargerList, setChargerList] = useState([]);
  const [selectTimeValue, setSelectTimeValue] = useState("HOUR_24");
  const [sessionsTimeData, setSessionTimeData] = useState([]);
  const [data, setData] = useState([]);
  const [swapStationCount, setSwapStationCount] = useState(0);
  const [totalSwapStationCount, setTotalSwapStationCount] = useState(0);
  const [timePeriod, setTimePeriod] = useState("");
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          // alert("You clicked outside of me!");
        } else {
          setOpen(true);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const [open, setOpen] = React.useState(false);
  // const handleClick = () => {
  //   if (open) {
  //     setOpen(false);
  //   } else {
  //     setOpen(true);
  //   }
  // };

  function useOutsideAlerterFilter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpenFilter(false);
          // alert("You clicked outside of me!");
        } else {
          setOpenFilter(true);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRefFilter = useRef(null);
  useOutsideAlerterFilter(wrapperRefFilter);
  const [openFilter, setOpenFilter] = React.useState(false);
  const handleFilter = () => {
    if (openFilter) {
      setOpenFilter(false);
    } else {
      setOpenFilter(true);
    }
  };

  // const [open, setOpen] = React.useState(false);
  const [droppedFilter, setDroppedFilter] = useState(false);
  const [droppedFilterDiv, setDroppedFilterDiv] = useState(false);

  // let history = useHistory();

  //   const someEventHandler = event => {
  //      history.push({
  //          pathname: '/secondpage',
  //          search: '?query=abc',
  //          state: { detail: 'some_value' }
  //      });
  //   };
  const history = useHistory();
  const viewSwappingStationList = (id, siteId) => {
    // history.push("/SwapStation/SwapStation/" + id + "-" + siteId);
    history.push({
      pathname: "/SwapStation/SwapStation/" + id + "-" + siteId,
      state: {
        id: id,
        test: timePeriod,
      },
    });
  };

  const columns = React.useMemo(() => [
    {
      Header: "Swapping Station Name",
      accessor: "swapStationName",
    },
    {
      Header: "Number of Slots",
      accessor: "numberOfBatteries",
      Cell: (row) => {
        return (
          <div style={{ paddingLeft: "20px" }}>
            {row.row?.original?.numberOfBatteries
              ? row.row?.original?.numberOfBatteries
              : 0}
          </div>
        );
      },
    },
    {
      Header: "Available Batteries",
      accessor: "chargedBatteries",
      Cell: (row) => {
        return (
          <div style={{ paddingLeft: "20px" }}>
            {row.row?.original?.chargedBatteries
              ? row.row?.original?.chargedBatteries
              : 0}
          </div>
        );
      },
    },
    {
      Header: "Charging Batteries",
      accessor: "chargingBatteries",
      Cell: (row) => {
        return (
          <div style={{ paddingLeft: "20px" }}>
            {row.row?.original?.chargingBatteries
              ? row.row?.original?.chargingBatteries
              : 0}
          </div>
        );
      },
    },
    {
      Header: "Fault Batteries",
      accessor: "faultBatteries",
      Cell: (row) => {
        return (
          <div style={{ paddingLeft: "20px" }}>
            {row.row?.original?.faultBatteries
              ? row.row?.original?.faultBatteries
              : 0}
          </div>
        );
      },
    },
    {
      Header: "Discharging Batteries",
      accessor: "dischargingBatteries",
      Cell: (row) => {
        return (
          <div style={{ paddingLeft: "20px" }}>
            {row.row?.original?.dischargingBatteries
              ? row.row?.original?.dischargingBatteries
              : 0}
          </div>
        );
      },
    },
    {
      Header: "Number of Swaps",
      accessor: (row) => row.numberOfSwaps + row.failureSwaps,
      Cell: ({ row }) => {
        const totalSwaps =
          (row?.original?.numberOfSwaps ? row.original.numberOfSwaps : 0) +
          (row?.original?.failureSwaps ? row.original.failureSwaps : 0);

        return <div style={{ paddingLeft: "20px" }}>{totalSwaps}</div>;
      },
    },
    {
      Header: "Temperature Inside",
      accessor: "temperature",
      Cell: (row) => {
        return (
          <div style={{ paddingLeft: "20px" }}>
            {row.row?.original?.temperature
              ? row.row?.original?.temperature
              : 0}
          </div>
        );
      },
    },
    {
      Header: "Temperature Outside",
      accessor: "outsideTemperature",
      Cell: (row) => {
        return (
          <div style={{ paddingLeft: "20px" }}>
            {row.row?.original?.outsideTemperature
              ? row.row?.original?.outsideTemperature
              : 0}
          </div>
        );
      },
    },
    {
      Header: "Status",
      accessor: (row) => {
        return (
          <>
            {row.status === "HEALTHY" ? (
              <p
                style={{
                  display: "flex",
                  justifyContent: "center",
                  cursor: "default",
                  background: "#1A873C",
                  border: "1px",
                  width: "130px",
                  color: "#fff",
                  borderRadius: "5px",
                  margin: "3px 0px 2px 2px",
                  padding: "3px",
                }}
              >
                <span style={{ margin: "0px" }}>Healthy</span>
              </p>
            ) : row.status === "OFFLINE" ? (
              <p
                style={{
                  display: "flex",
                  justifyContent: "center",
                  cursor: "default",
                  background: "#0049b0",
                  border: "1px",
                  width: "130px",
                  color: "#fff",
                  borderRadius: "5px",
                  margin: "3px 0px 2px 2px",
                  padding: "3px",
                }}
              >
                <span style={{ margin: "0px" }}>Offline</span>
              </p>
            ) : row.status === "UNDERMAINTENANCE" ? (
              <p
                style={{
                  display: "flex",
                  justifyContent: "center",
                  cursor: "default",
                  background: "orange",
                  border: "1px",
                  width: "180px",
                  color: "#fff",
                  borderRadius: "5px",
                  margin: "3px 0px 2px 2px",
                  padding: "3px 0px",
                }}
              >
                <span style={{ margin: "0px" }}>Under Maintenance</span>
              </p>
            ) : row.status === "FAULT" ? (
              <p
                style={{
                  display: "flex",
                  justifyContent: "center",
                  cursor: "default",
                  background: "red",
                  border: "1px",
                  width: "130px",
                  color: "#fff",
                  borderRadius: "5px",
                  margin: "3px 0px 2px 2px",
                  padding: "3px 0px",
                }}
              >
                <span style={{ margin: "0px" }}>Fault</span>
              </p>
            ) : (
              <></>
            )}
          </>
        );
      },
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: (row) => {
        return (
          <>
            <img
              src={require("assets/view.png").default}
              style={{ marginRight: 15, cursor: "pointer" }}
              onClick={() =>
                viewSwappingStationList(
                  row.row.original.swapStationId,
                  row.row.original.siteId
                )
              }
            />
          </>
        );
      },
    },
  ]);

  const getSites = useCallback(async (filter) => {
    let callString = "bss/site/siteList";
    if (filter?.cityId > 0) {
      callString += "?cityId=" + filter.cityId;
      if (filter.stateId > 0) {
        callString += "&stateId=" + filter.stateId;
      }
      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter?.stateId > 0) {
      callString += "?stateId=" + filter.stateId;

      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter?.zoneId > 0) {
      callString += "?zoneId=" + filter.zoneId;
    }
    await getRequestInAssets(callString)
      .then((res) => {
        if (res.data != null) {
          setSitesList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getChargers = useCallback(async (siteId) => {
    await getRequestInAssets(
      `bss/swappingStation/getAllSwappingStationsBySite?siteId=${siteId}`
    )
      .then((res) => {
        if (res.data != null) {
          setChargerList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });

    if (event.target.name === "time") {
      setSelectTime(event.target.value);

      if (value === "HOUR_12") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 43200,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_12");
      }
      if (value === "HOUR_24") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
      if (value === "WEEK") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 604800,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK");
      }
      if (value === "WEEK_2") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 1209600,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK_2");
      }
      if (value === "MONTH") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 2628000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH");
      }
      if (value === "MONTH_3") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 7884000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH_3");
      }
      if (value === null) {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
    }

    if (event.target.name == "siteId") {
      setFilter({ ...filter, [name]: value, swapStationId: "" });
      getChargers(event.target.value);
    }
  };

  const handleClick = (btnType) => {
    if (open) {
      if (btnType == "reset") {
        getSwapSessionData(filterInitialValue);
        getSwapStationInfo(
          filterInitialValue.startDate,
          filterInitialValue.endDate
        );
        getSwappedEnergyData(filterInitialValue);
        getSwapstationFaultData(filterInitialValue);
        setSelectTimeValue(filterInitialValue.time);
        setFilter(filterInitialValue);
        setChargerList([]);
      } else {
        filter.siteId = filter.siteId;
        filter.swapStationId = filter.swapStationId;
        filter.time = filter.time;
        getSwapSessionData(filter);
        getSwapStationInfo(filter.startDate, filter.endDate, filter);
        getSwappedEnergyData(filter);
        getSwapstationFaultData(filter);
        setSelectTimeValue(selectTime);
      }
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const pageLimitHandle = (string, limit) => {
    getSwapStationInfo(filter.startDate, filter.endDate, filter, string, limit);
  };

  // const pageLimitHandle = (limit) => {
  //   console.log(limit,"limit")
  //   pageLimit = limit;
  //   // getSwapStationInfo(filter.startDate, filter.endDate,filter, limit);
  // }

  const getSwapStationInfo = useCallback(
    async (time, a, b, c, limit) => {
      return;
      //todo deprecate this function
      // c === "front" ? offset + 10 :offset - 10

      if (c === "front") {
        offset = offset + 10;
        console.log(offset, "OFFSEYT WORKING");
      } else {
        console.log("am runing ELSE");
        if (offset > 0) {
          offset = offset - 10;
        }
      }
      await getRequest(
        `swapStation/swapStationInfo?${time}&limit=${
          limit ? limit : pageLimit
        }&offset=${offset > 0 ? offset : 0}`
      )
        // await getRequest(` swapping/swappingInfo?${time}&limit=10&offset=0`)

        .then((res) => {
          if (res && res?.data) {
            setSwapStationsData(res?.data?.swapStationsInfo);
            setSwapStationCount(res?.data?.count);
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    },
    [swapStationsData, swapStationCount]
  );
  console.log("setSwapStationCount", swapStationCount);
  const searchBySwapStationID = async (filter, searchString) => {
    if (searchString === undefined || searchString === "") {
      searchString = "";
      getSwapStationInfo(data);
    }
    try {
      if (searchString != "" || searchString != undefined)
        searchString = `?filter=` + searchString;
      await getRequest(`swapStation/swapStationInfo${searchString}`)
        .then((res) => {
          if (res && res?.data) {
            setSwapStationsData(res?.data?.swapStationsInfo);
            setSwapStationCount(res?.data?.count);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    } catch (e) {
      console.log(e, "Error");
    }
  };
  const searchSwapStationByFilter = (filter, searchString) => {
    if (filter === undefined || filter === "") {
      getSwapStationInfo("timeFilterEnum=HOUR_24");
    }
    // if (searchString.includes("timeFilterEnum")) {
    //   setTimePeriod(
    //     searchString.substring(
    //       searchString.lastIndexOf("=") + 1,
    //       searchString.length
    //     )
    //   );
    // }
    setData(searchString);
    getRequest(`swapStation/swapStationInfo?${filter}`)
      .then((res) => {
        if (res && res?.data) {
          setSwapStationsData(res?.data?.swapStationsInfo);
          setSwapStationCount(res?.data?.count);
          // setTotalSwapStationCount(res?.data?.swapStationCount);
        } else {
          setSwapStationsData([]);
          setSwapStationCount(0);
        }
      })
      .catch((err) => {
        setSwapStationsData([]);
        setSwapStationCount(0);
        console.error("Error", err);
      });
  };

  const countSwapStationByFilter = () => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    var query =
      (headerFilterObj?.stateId === undefined || headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);

    getRequest(`swapStation/swapStationInfo?${query}`)
      .then((res) => {
        if (res && res?.data) {
          setTotalSwapStationCount(res?.data?.count);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  const getSwappedEnergyData = useCallback(
    async (filter) => {
      let callString =
        `bss/getBatteryEnergyDetails?startDate=` +
        filter.startDate +
        `&endDate=` +
        filter.endDate;
      if (filter.cityId > 0) {
        callString += "&cityId=" + filter.cityId;
      }
      if (filter.stateId > 0) {
        callString += "&stateId=" + filter.stateId;
      }
      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
      if (filter.siteId > 0) {
        callString += "&siteId=" + filter.siteId;
      }
      if (filter.swapStationId > 0) {
        callString += "&chargerId=" + filter.swapStationId;
      }
      await getRequest(callString)
        .then((res) => {
          if (res && res?.data) {
            setSwapData(res?.data);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    [swapData]
  );

  const getSwapSessionData = useCallback(
    async (filter) => {
      let callString =
        `swapStation/swapStationSessionTimeGraph?timeFilterEnum=` + filter.time;
      if (filter.cityId > 0) {
        callString += "&cityId=" + filter.cityId;
      }
      if (filter.stateId > 0) {
        callString += "&stateId=" + filter.stateId;
      }
      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
      if (filter.siteId > 0) {
        callString += "&siteId=" + filter.siteId;
      }
      if (filter.swapStationId > 0) {
        callString += "&swapStationId=" + filter.swapStationId;
      }

      await getRequest(callString)
        .then((res) => {
          if (res && res?.data) {
            setSessionTimeData(res?.data);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    [sessionsTimeData]
  );

  const getSwapstationFaultData = useCallback(
    async (filter) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      // var query =
      // // (filter?.startDate
      // //   ? "startDate=" + filter.startDate
      // //   : startDate
      // //   ? "startDate=" + startDate
      // //   : "") +
      // // (filter?.endDate
      // //   ? "&endDate=" + filter?.endDate
      // //   : endDate
      // //   ? "&endDate=" + endDate
      // //   : "") +
      // (filter?.siteId === undefined || filter?.siteId === ""
      //   ? ""
      //   : "&siteId=" + filter.siteId) +

      // (filter?.chargerId === undefined || filter?.chargerId === "" || filter?.chargerId === null
      //   ? ""
      //   : "&swapStationId=" + filter.chargerId) +

      // (filter?.time === undefined || filter?.time === ""
      //   ? ""
      //   : "&timeFilterEnum=" + filter.time) +

      // (headerFilterObj?.stateId === undefined ||
      // headerFilterObj?.stateId === ""
      //   ? ""
      //   : "&stateId=" + headerFilterObj.stateId) +
      // (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
      //   ? ""
      //   : "&cityId=" + headerFilterObj.cityId) +
      // (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
      //   ? ""
      //   : "&zoneId=" + headerFilterObj.zoneId) +
      //   (headerFilterObj?.chargerId === undefined || headerFilterObj?.chargerId === ""
      //   ? ""
      //   : "&swapStationId=" + headerFilterObj.chargerId? headerFilterObj.chargerId : null);

      let callString =
        `swapStation/swapStationFaultGraph?timeFilterEnum=` + filter.time;
      if (filter.cityId > 0) {
        callString += "&cityId=" + filter.cityId;
      }
      if (filter.stateId > 0) {
        callString += "&stateId=" + filter.stateId;
      }
      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
      if (filter.siteId > 0) {
        callString += "&siteId=" + filter.siteId;
      }
      if (filter.swapStationId > 0) {
        callString += "&swapStationId=" + filter.swapStationId;
      }
      await getRequest(callString)
        // await getRequest(`swapStation/swapStationFaultGraph?` + query)
        .then((res) => {
          if (res && res?.data) {
            setSwapSationFault(res?.data);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    [swapStationFault]
  );

  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    if (headerFilterObj !== null) {
      filter.stateId = headerFilterObj.stateId;
      filter.cityId = headerFilterObj.cityId;
      filter.zoneId = headerFilterObj.zoneId;
    }
    getSites(headerFilterObj);
    getSwapSessionData(filter);
    getSwapStationInfo(filter.startDate, filter.endDate, filter);
    getSwappedEnergyData(filter);
    getSwapstationFaultData(filter);
    countSwapStationByFilter();
    pageLimitHandle();
    window.scrollTo({ top: 0 });
    return;

    // pageLimitHandle();
  }, [props.headerFilter]);

  return (
    <>
      <h2
        id="SwapStation_Heading"
        className={cn(styles.medium_title, styles.medium_title_layout)}
      >
        {"Swap Station"}
      </h2>

      <div
        id="SwapStation_TotalCount_Container"
        className={cn(styles.block8, styles.block8_layout)}
      >
        <div
          id="SwapStation_TotalCount_Container1"
          className={cn(styles.block8_item)}
        >
          <div
            id="SwapStation_TotalCount_block"
            className={cn(styles.block23, styles.block23_layout)}
          >
            <div className={cn(styles.box10, styles.box10_layout)} />
            <div
              id="SwapStation_TotalCount_box"
              className={cn(styles.box11, styles.box11_layout)}
            >
              <>
                <img
                  id="SwapStation_TotalCount_img"
                  src={require("assets/total_batteries_icon.png").default}
                  style={{
                    marginLeft: "7px",
                    marginTop: "6px",
                    cursor: "pointer",
                  }}
                />
              </>
            </div>
          </div>
        </div>
        <div className={cn(styles.block8_spacer)} />
        <div
          id="SwapStation_TotalCount_TextBlock"
          className={cn(styles.block8_item1)}
        >
          <div
            id="SwapStation_TotalCount_TextLayout"
            className={cn(
              styles.swapping_header_count_container,
              styles.block21_layout
            )}
          >
            <div
              id="SwapStation_TotalCount_Text"
              className={cn(styles.block22, styles.block22_layout)}
            >
              <h3 className={cn(styles.subtitle2, styles.subtitle2_layout)}>
                {"Total Count"}
              </h3>
            </div>

            <div
              id="SwapStation_TotalCount_value"
              className={cn(
                styles.small_text_body1,
                styles.small_text_body1_layout
              )}
            >
              {totalSwapStationCount}
            </div>
            <div
              className={cn(
                styles.small_text_body1,
                styles.small_text_body1_layout1
              )}
            >
              {""}
            </div>
          </div>
        </div>
      </div>

      <div
        id="SwapStation_Graph_Filter_block"
        ref={wrapperRef}
        className={cn(styles.block1, styles.block1_layout)}
        style={{ cursor: "pointer" }}
        onClick={() => setDroppedFilter(!droppedFilter)}
      >
        <div
          id="SwapStation_Graph_Filter_block1"
          className={cn(styles.block2, styles.block2_layout)}
        >
          <div
            id="SwapStation_Graph_Filter_layout"
            className={cn(styles.block2_item)}
          >
            <div
              id="SwapStation_Graph_Filter_layout1"
              className={cn(styles.block3, styles.block3_layout)}
            >
              <div
                id="SwapStation_Graph_Filter_img"
                style={{
                  "--src": `url(${require("assets/filterblack.png").default})`,
                }}
                className={cn(styles.image1, styles.image1_layout)}
              />
            </div>
          </div>

          <div className={cn(styles.block2_spacer)} />

          <div
            id="SwapStation_Graph_Filter_Title"
            className={cn(styles.text_body, styles.text_body_layout)}
          >
            {"Filters"}
          </div>
          {open && (
            <div id="filter" open={open}>
              <div
                id="SwapStation_Graph_Filter_selectBlock"
                style={{ cursor: "pointer" }}
                className={cn(
                  styles.status1_block,
                  styles.status1_block_layout
                )}
              >
                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="time"
                    id="time"
                    onChange={handleChange}
                    value={filter.time}
                  >
                    <option value="-1" disabled>
                      Select Time Period
                    </option>
                    <option value="HOUR_24" selected>
                      Last 24 hours
                    </option>
                    <option value="HOUR_12">Last 12 hours</option>
                    <option value="WEEK">Last 1 week</option>
                    <option value="WEEK_2">Last 2 weeks</option>
                    <option value="MONTH">Last 1 month</option>
                    <option value="MONTH_3">Last 3 months</option>
                  </select>
                </div>
                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="siteId"
                    id="siteId"
                    onChange={handleChange}
                    value={filter.siteId}
                  >
                    <option value="-1" selected>
                      Select Site
                    </option>
                    {sitesList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="swapStationId"
                    id="swapStationId"
                    onChange={handleChange}
                    value={filter.swapStationId}
                  >
                    <option value="" disabled selected>
                      Select Swap Station
                    </option>
                    {chargerList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <div>
                  <Button
                    id="SwapStation_Graph_Filter_ResetButton"
                    style={{
                      background: "#E3324C",
                      color: "white",
                      margin: "15px 0px 6px 35px",
                      width: "85px",
                      height: "28px",
                    }}
                    onClick={() => {
                      handleClick("reset");
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    id="SwapStation_Graph_Filter_ApplyButton"
                    style={{
                      background: "#23297A",
                      color: "white",
                      margin: "15px 0px 6px 20px",
                      width: "85px",
                      height: "28px",
                    }}
                    onClick={() => {
                      handleClick("apply");
                    }}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        id="SwapStation_Graph_main_block"
        className={cn(styles.flex4, styles.flex4_layout)}
      >
        <div id="SwapStation_SwapsGraph" className={cn(styles.flex4_item)}>
          <div
            id="SwapStation_SwapsGraph_block"
            className={cn(styles.block6, styles.block6_layout)}
          >
            <div
              id="SwapStation_SwapsGraph_layout"
              className={cn(styles.block7, styles.block7_layout)}
            >
              <h5
                id="SwapStation_SwapsGraph_title"
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>
                  {"Swaps"}
                  <EnergyComponentChartSwap
                    data={swapData}
                    selectValue={selectTimeValue}
                  />
                </pre>
              </h5>
            </div>
          </div>
        </div>
        <div className={cn(styles.flex4_spacer)} />
        <div
          id="SwapStation_SessionTimeGraph"
          className={cn(styles.flex4_item)}
        >
          <div
            id="SwapStation_SessionTimeGraph_block"
            className={cn(styles.block6, styles.block6_layout)}
          >
            <div
              id="SwapStation_SessionTimeGraph_layout"
              className={cn(styles.block7, styles.block7_layout)}
            >
              <h5
                id="SwapStation_SessionTimeGraph_title"
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>
                  {"Swaps/Session Time"}
                  <EnergyComponentChartSessionTime
                    data={sessionsTimeData}
                    selectValue={selectTimeValue}
                  />
                </pre>
              </h5>
            </div>
          </div>
        </div>
        <div className={cn(styles.flex4_spacer)} />
        <div id="SwapStation_FaultedGraph" className={cn(styles.flex4_item)}>
          <div
            id="SwapStation_FaultedGraph_block"
            className={cn(styles.block6, styles.block6_layout)}
          >
            <div
              id="SwapStation_FaultedGraph_layout"
              className={cn(styles.block7, styles.block7_layout)}
            >
              <h5
                id="SwapStation_FaultedGraph_title"
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>
                  {"Faulted"}
                  <EnergyComponentsLine
                    data={swapStationFault}
                    selectValue={selectTimeValue}
                  />
                </pre>
              </h5>
            </div>
          </div>
        </div>
      </div>
      <hr className={cn(styles.line, styles.line_layout)} />

      <Styles>
        <NewTableAndSearchMasterFilter
          pageLimitHandle={pageLimitHandle}
          searchOpts={{
            // onSearch: searchByKey,
            // onSearch: searchBySwapStationID,
            placeholder: "Search by Swapping Station",
            filter: true,
            onFilterSearch: searchSwapStationByFilter,
            screentype: "swapping",
          }}
          headerFilter={props.headerFilter}
          columns={columns}
          data={swapStationsData}
          paginationDoubleScreen={true}
          onReset={getSwapStationInfo}
          swapStationCount={swapStationCount}
        />
      </Styles>
      {/* <hr className={cn(styles.line, styles.line_layout)} /> */}
    </>
  );
}
export default function SwappingStationComponent(props) {
  let Urls = window.location.href.toString().split(window.location.host)[1];
  const [headerFilter, setHeaderFilter] = useState(true);
  return (
    <>
      <Master
        swappingName={Urls}
        opts={props}
        screen={SwappingStation}
        showStatus={true}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}

SwappingStationComponent.inStorybook = true;
